import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthServiceCustom} from 'src/shared/service/auth.service';
import {AbstractDataProvider} from './AbstractDataProvider';
import {Router, RoutesRecognized} from '@angular/router';
import {forkJoin, of} from 'rxjs';
import {Dictionary} from '../assets/dictionary';
import {DictionaryService} from '../shared/service/dictionary.service';
import {LeftMenuComponent} from './left-menu/left-menu.component';
import {finalize} from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { LoginProvider } from 'src/shared/service/login.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  @ViewChild('leftMenu') leftMenuComponent: LeftMenuComponent;

  title = 'html-skeleton';
  notIsLoggedIn = true;
  widthOfRightContainer = 'calc(100%)';
  menuCollapsed = false;
  isFaqHidden = true;

  display: boolean;
  alertMessage: string;
  showLoader: boolean;
  success: boolean;

  constructor(
    private authService: AuthServiceCustom,
    private abstractDataProvider: AbstractDataProvider,
    private dictionaryService: DictionaryService,
    private router: Router,
    public authOKTA: AuthService,
    private loginProvider: LoginProvider) {
    router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        let userType = '';
        let recordNum = '';
        let wpUserNum = '';

        if (event.url.indexOf('RecordNum') >= 0) {
          recordNum = this.authService.getQueryStringParam(event.url, 'RecordNum');
          if (recordNum && recordNum != this.authService.RecordNum) {
            this.authService.RecordNum = recordNum;
          }
        }
        if (event.url.indexOf('WpUserNum') >= 0) {
          wpUserNum = this.authService.getQueryStringParam(event.url, 'WpUserNum');
          if (wpUserNum && wpUserNum != this.authService.RecordNum) {
            this.authService.WpUserNum = wpUserNum;
          }
        }
        if (event.url.indexOf('UserType') >= 0) {
          userType = this.authService.getQueryStringParam(event.url, 'UserType');
          if (userType && userType != this.authService.UserType) {
            this.authService.UserType = userType;
            this.authService.accessTokenRemovedSubj.next(false);
            this.getCurrentTabBasedUserInfo();
          }
        }
        if (event.urlAfterRedirects.indexOf('index') >= 0) {
          this.getClientBasedConfiguration();
        }
        this.authService.routeChangedSubj.next(event.url);
      }
    });
  }

  ngOnInit() {

    this.getClientBasedConfiguration();
    if (this.authService.isAuthenticated()) {
      this.notIsLoggedIn = false;
      this.widthOfRightContainer = 'calc(100% - 300px)';
    }


    this.authService.accessTokenRemovedSubj.subscribe((posts) => {

      window.setTimeout(() => this.notIsLoggedIn = posts); // To avoid ExpressionChangedAfterItHasBeenCheckedError error

      this.widthOfRightContainer = 'calc(100% - 300px)';

      if (this.notIsLoggedIn) {
        window.setTimeout(() => this.widthOfRightContainer = 'calc(100%)'); // To avoid ExpressionChangedAfterItHasBeenCheckedError error
      }
    });
  }

  onConfirm() {
    this.display = false;
  }

  changeFAQState() {
    console.log('changeFAQState', 'changeFAQState');
    this.isFaqHidden = !this.isFaqHidden;
    if (!this.isFaqHidden && !this.menuCollapsed) {
      this.leftMenuComponent.collapseOnDesktop();
    }
  }

  getCurrentTabBasedUserInfo() {
    // Make API call to get WpUserNum
  }

  getClientBasedConfiguration() {
    this.showLoader = true;
    forkJoin([
      this.abstractDataProvider.getData('api/Configuration/GetClientBasedConfiguration'),
      of(Dictionary)
    ])
      .pipe(finalize(() => {
        this.showLoader = false;
      }))
      .subscribe(
        ([config, dictionary]) => {
          this.success = true;
          sessionStorage.setItem('ProxyOnlyFlag', config?.ProxyOnlyFlag);
          this.authService.clientCode = config.ClientCode;
          this.authService.WpProxyFlag = config.WpProxyFlag;
          this.authService.clientAddress = config.ClientAddress;
          this.authService.wpCompanyName = config.WpCompanyName;
          this.authService.wpCompanyShortName = config.WpCompanyShortName;
          this.authService.wpCompanyPhone = config.WpCompanyPhone;
          this.authService.wpCompanyEmail = config.WpCompanyEmail;
          this.authService.wpCompanyWebsite = config.WpCompanyWebsite;
          this.authService.clientHeader = config.ClientHeader;
          this.authService.wpContactPhone = config.WpContactPhone;
          this.authService.wpContactFax = config.WpContactFax;
          this.authService.wpContactEmail = config.WpContactEmail;
          this.authService.wpIrEmail = config.WpIrEmail;
          this.authService.wpFaqFile = config.WpFaqFile;
          this.authService.loginMessage = config.LoginMessage;
          this.authService.transactionCodes = config.TransactionCodes;
          this.authService.distributionCodes = config.DistributionCodes;
          this.authService.buildVersion = config.BuildVersion;
          this.authService.appVersion = config.AppVersion;
          this.authService.Auth0ConnectionPrefix = config.Auth0ConnectionPrefix;
          this.authService.configurationSet$.next();

          const gridColumnConfigs = config.GridColumnConfigs;
          Object.keys(gridColumnConfigs).forEach(key => {
            gridColumnConfigs[key].selectable = gridColumnConfigs[key].selectable === 'Y';
            gridColumnConfigs[key].allowSort = gridColumnConfigs[key].allowSort === 'Y';

            // TODO: right now the same for all grids
            gridColumnConfigs[key].sortable = {
              allowUnsort: false,
              mode: 'single'
            };

          });


          this.authService.gridColumnConfigs = config.GridColumnConfigs;

          if (config.WpProxyFlag !== 'Y') {
            config.PageWiseIntroTextList = config.PageWiseIntroTextList.filter(i => i.PageName !== 'PROXY');
          }
          this.authService.IntroText = config.PageWiseIntroTextList;

          if (config.CommonTerms) {
            dictionary = {...dictionary};
            for (let key in dictionary) {
              for (let term of config.CommonTerms) {
                dictionary[key] = dictionary[key].replace(`**${term.Key}**`, term.Value);
              }
            }
          }
          this.dictionaryService.setDictionary(dictionary);

          this.authService.configReady = true;
          this.authService.clientConfigLoaded.next();
          const paletteUrl = this.authService.clientPalette;
          $('head').append('<link rel="stylesheet" href="' + paletteUrl + '" type="text/css" />');
        },
        error => {
          this.display = true;
          this.alertMessage = 'Request failed. Please try again later.';
        });
  }

  collapseMenu(collapsed: boolean) {
    this.menuCollapsed = collapsed;
  }

makeLoginCall(accessToken: string) {

        // this.jqueryDialogService.showLoaderForSearchManagerCall = true;
        //this.ngxService.stop()
        this.authService.resetAllLocalStorageData();
        this.authService.AccessToken = accessToken;
        this.authService.newTokenSet = false;
        this.authService.tokenProfileDataReadFromSessionStorage = false;
        this.authService.HasBeenOnceOpened = true;
        //this.getUserInfo();
        this.getConfigurationDataOfLoggedInUser();
    }

getConfigurationDataOfLoggedInUser() {
    // this.authService.setAuthentication(this.userProfile.UserId);

    this.loginProvider.getData('api/Configuration/GetLoggedInUserConfigurationData').subscribe(
      (posts) => {
        this.authService.UserType = posts.UserType;
        this.authService.UserName = posts.UserName;
        this.authService.UserClass = posts.UserClass;
        this.authService.RecordNum = posts.RecordNum;
        this.authService.WpUserNum = posts.WpUserNum;
        this.authService.accessTokenRemovedSubj.next(false);
        this.authService.navigateToUrl('home');
      },
      (error) => {
        this.display = true;
        //this.alertMessage = this.dictionaryPipe.transform('DEFAULT_ERROR'); // TODO: replace with error message from BE
      }
    );
  }

}
